import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ChevronDownIcon } from "lucide-react";
export interface AccordionEntry {
  emoji: string;
  title: string;
  content: string;
}
interface AccordionProps {
  items: AccordionEntry[];
  variant?: "green" | "gold";
}
export function Accordion({
  items,
  variant = "green"
}: AccordionProps) {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const accent = variant === "gold" ? "text-gold" : "text-italian-green";
  return <div className="space-y-3" data-id="element-11" data-mp="2i42ybi9e7iap">
      {items.map((item, i) => {
      const isOpen = openIndex === i;
      return <div key={item.title} className="overflow-hidden rounded-2xl border border-sand bg-cream shadow-sm" data-id="element-12" data-mp="2w2jb9qxum51a" data-mpi={i}>
            <button type="button" onClick={() => setOpenIndex(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center gap-3 px-4 py-4 text-left" data-id="element-13" data-mp="11pulifefcnc9">
              <span className="text-xl shrink-0" aria-hidden="true" data-id="element-14" data-mp="3g5x62dj6jj62">
                {item.emoji}
              </span>
              <span className={`flex-1 text-sm font-bold leading-snug ${accent}`} data-id="element-15" data-mp="3l0ublah93ae7">
                {item.title}
              </span>
              <motion.span animate={{
            rotate: isOpen ? 180 : 0
          }} transition={{
            duration: 0.2
          }} className="shrink-0" data-id="element-16" data-mp="3utrw1m5sz9fg">
                <ChevronDownIcon className={`h-5 w-5 ${accent}`} aria-hidden="true" data-id="element-17" data-mp="7n95475u4mvl" />
              </motion.span>
            </button>
            <AnimatePresence initial={false} data-id="element-18" data-mp="hmzww130gnrz">
              {isOpen && <motion.div key="content" initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: "auto",
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.25
          }} className="overflow-hidden" data-id="element-19" data-mp="2eeqflr76a533">
                  <div className="whitespace-pre-line border-t border-sand px-4 py-4 text-[13px] leading-relaxed text-ink/80" data-id="element-20" data-mp="27clhzymtzppn">
                    {item.content}
                  </div>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}